import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20lifestyle%20composition%20featuring%20elegantly%20arranged%20minimalist%20clothing%20and%20accessories%20on%20a%20warm%20sand-toned%20surface%2C%20surrounded%20by%20dried%20pampas%20grass%20and%20soft%20natural%20textiles%2C%20gentle%20morning%20sunlight%20casting%20long%20dreamy%20shadows%2C%20editorial%20photography%20with%20creamy%20warm%20tones%20and%20organic%20composition%2C%20shallow%20depth%20of%20field%20with%20ethereal%20bokeh%20background%2C%20premium%20aesthetic%20with%20neutral%20earthy%20palette&width=1800&height=1200&seq=hero-main-v3&orientation=landscape"
          alt="ACBuySpreadsheet – Premium fashion and lifestyle product collections with elegant minimalist styling"
          title="ACBuySpreadsheet – Smart Product Discovery & Spreadsheet Tracking System"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/45 via-foreground-900/30 to-foreground-900/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <p className="text-sm md:text-base text-background-50/80 font-medium mb-4 tracking-wide">
              / ACBUYSPREADSHEET SYSTEM
            </p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
              ACBuySpreadsheet – The Most Advanced Spreadsheet System for Tracking &amp; Optimization
            </h1>
            <p className="text-base md:text-lg text-background-50/80 leading-relaxed mb-8 max-w-xl">
              A powerful acbuyspreadsheet framework designed for data tracking, automation, and performance optimization. Compare tools, learn workflows, and improve your spreadsheet efficiency.
            </p>

            <div className="flex flex-col sm:flex-row items-start gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-line"></i>
              </a>
              <Link
                to="/article/acbuyspreadsheet-guide"
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-background-50/30 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Explore ACBuy Spreadsheet
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}